import { submitInvitation } from '@/api'
import { checkMobile } from '@/utils'
import { Button, Form, Input, Radio, Result, Selector, Space, Stepper, Toast } from 'antd-mobile'
import { useState } from 'react'

function Invite() {
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm<any>()

  const handleInvite = async (values: any) => {
    try {
      const params = {
        ...values,
        stayDays: values.stayDays?.join(','),
      }
      await submitInvitation(params)
      setVisible(false)
      // Modal.alert({
      //   title: '提示',
      //   content: '报名成功！',
      //   confirmText: '确定',
      //   onConfirm: () => {
      //     history.go(-1)
      //   },
      // })
    } catch (err: any) {
      Toast.show({ content: err })
    }
  }
  return (
    <div className='pb-6'>
      {visible ? (
        <Form
          form={form}
          onFinish={handleInvite}
          footer={
            <Button block type='submit' color='primary' size='large'>
              报名参加
            </Button>
          }
        >
          <Form.Item name='name' label='姓名' rules={[{ required: true, message: '请输入姓名' }]}>
            <Input placeholder='请输入姓名' />
          </Form.Item>
          <Form.Item
            name='phone'
            label='联系电话'
            rules={[{ required: true, validator: checkMobile }]}
          >
            <Input placeholder='请输入联系电话' />
          </Form.Item>
          <Form.Item
            name='company'
            label='公司名称'
            rules={[{ required: true, message: '请输入公司名称' }]}
          >
            <Input placeholder='请输入公司名称' />
          </Form.Item>
          <Form.Item
            name='position'
            label='职位'
            rules={[{ required: true, message: '请输入职位' }]}
          >
            <Input placeholder='请输入职位' />
          </Form.Item>
          <Form.Item
            name='province'
            label='所属省份'
            rules={[{ required: true, message: '请输入所属省份' }]}
          >
            <Input placeholder='请输入所属省份' />
          </Form.Item>
          <Form.Item
            name='attendance'
            label='参会人数'
            rules={[{ required: true, message: '参会人数不能为0' }]}
          >
            <Stepper min={1} />
          </Form.Item>
          <Form.Item
            name='lunchState'
            label='是否用午餐（4月22号）'
            rules={[{ required: true, message: '请选择是否用午餐（4月22号）' }]}
          >
            <Radio.Group>
              <Space style={{ '--gap': '30px' }}>
                <Radio value='1'>是</Radio>
                <Radio value='0'>否</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name='dinnerState'
            label='是否参加晚宴'
            rules={[{ required: true, message: '请选择是否参加晚宴' }]}
          >
            <Radio.Group>
              <Space style={{ '--gap': '30px' }}>
                <Radio value='1'>是</Radio>
                <Radio value='0'>否</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name='stayDays'
            label='住宿日期'
            rules={[{ required: true, message: '请选择住宿日期' }]}
          >
            <Selector
              columns={3}
              multiple
              options={[
                { label: '4月21日', value: '4月21日' },
                { label: '4月22日', value: '4月22日' },
                { label: '不住宿', value: '不住宿' },
              ]}
            />
          </Form.Item>
        </Form>
      ) : (
        <div className='pt-6'>
          <Result status='success' title='报名成功！' />
        </div>
      )}
    </div>
  )
}

export default Invite
